import React, {Component} from 'react'
import axios from 'axios'
import Header from '../Header'
import 'react-select/dist/react-select.css'
import {Link} from 'react-router-dom'
import * as UrlHelpers from '../../helpers/urlHelpers'
import * as GymHelpers from '../../helpers/gymHelpers'
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap'
import _ from 'lodash'
import UserOrLogin from '../UserOrLogin'
import EnsureUser from '../EnsureUser'
import DisplayWall from './DisplayWallEdit'
import ListProblems from '../problems/ListProblems'
import Problem from '../problems/Problem'
import AddProblem from '../problems/AddProblem'
import RecordAscent from '../problems/RecordAscent'
import Loading from '../Loading'
import LaddaButton, {SLIDE_UP} from '../LaddaButton'

function findHoldIndex(hold, holds) {
  let index = -1
  let xmin = Math.floor(hold.xmin)
  let xmax = Math.floor(hold.xmax)
  let ymin = Math.floor(hold.ymin)
  let ymax = Math.floor(hold.ymax)
  _.each(holds, (h, i) => {
    if (
      Math.floor(h.xmin) === xmin &&
      Math.floor(h.xmax) === xmax &&
      Math.floor(h.ymin) === ymin &&
      Math.floor(h.ymax) === ymax
    ) {
      index = i
      return index
    }
  })
  return index
}

class Wall extends Component {
  constructor(props) {
    super(props)
    this.state = {
      holds: [],
      problems: this.props.problems || [],
      scale: 1.0,
      isAddingProblem: false,
      gymId: this.props.gym && this.props.gym.id,
      wallId: this.props.wall && this.props.wall.id,
      gym: this.props.gym,
      wall: this.props.wall,
      walls: this.props.gym && this.props.gym.walls,
      problemKey: this.props.problemKey,
      activeProblem: this.props.activeProblem,
      newProblemGrade: GymHelpers.grades[0],
      loading: true,
    }
    this.onResize = this.onResize.bind(this)
    this.handleHoldClick = this.handleHoldClick.bind(this)
    this.getWallAndHolds = this.getWallAndHolds.bind(this)
    this.handleListProblemsClick = this.handleListProblemsClick.bind(this)
    this.handleAddProblemClick = this.handleAddProblemClick.bind(this)
    this.setActiveProblem = this.setActiveProblem.bind(this)
    this.setImageRef = this.setImageRef.bind(this)
    this.addHoldMetadata = this.addHoldMetadata.bind(this)
  }

  getWallAndHolds() {
    if (!this.state.gym || !this.state.wallId) {
      return
    }
    let holds = []
    let storageRef = window.firebaseStorage.ref()
    let wallId = this.state.wallId
    let gymKey = this.state.gym.key
    let wallDir = UrlHelpers.getWallDir(gymKey, wallId)
    let wallHoldsRef = storageRef.child(wallDir + '/holds.json')
    let res = wallHoldsRef
      .getDownloadURL()
      .then(function (url) {
        return axios.get(url)
      })
      .catch(e => {
        console.info('Error fetching holds file: ')
        console.info(e)
      })
      .then(response => {
        if (response && response.data) {
          let object = response.data.annotation ? response.data.annotation.object : response.data.object
          if(object){
            holds = object.map(hold => {
              return {
                xmax: Number(hold.bndbox.xmax),
                ymax: Number(hold.bndbox.ymax),
                xmin: Number(hold.bndbox.xmin),
                ymin: Number(hold.bndbox.ymin),
                selected: false,
              }
            })
            holds = GymHelpers.sortHolds(holds)
          }
          else{
            console.info("No object in wall response: ", response)
            holds = []
          }
        } else {
          holds = []
        }
      })
      .then(() => {
        var img = new Image()
        img.src = this.state.wall.wallUrl
        let _this = this
        let clientWidth =
          (this.imageRef && this.imageRef.width) ||
          (this.containerRef && this.containerRef.width) ||
          window.innerWidth
        let clientHeight =
          (this.imageRef && this.imageRef.height) ||
          (this.containerRef && this.containerRef.height) ||
          window.innerHeight
        this.setState({
          clientWidth: clientWidth,
          clientHeight: clientHeight,
          holds: holds,
        })
        img.onload = function (e) {
          _this.setState(
            {
              imageWidth: this.width,
              imageHeight: this.height,
              img: img,
              scale: clientWidth / this.width,
              loading: false,
            },
            () => {
              _this.onResize()
            },
          )
        }
      })
    return res
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize, false)
    // TODO: NATE: would be nice if getwallandholds always returned a promise
    let promise = this.getWallAndHolds()
    promise &&
      promise.then(() => {
        this.state.activeProblem &&
          this.setActiveProblem(this.state.activeProblem)
      })
  }

  componentWillReceiveProps(nextProps) {
    this.setState(
      {
        // holds: nextProps.holds,
        scale: 1.0,
        isAddingProblem: false,
        gymId: nextProps.gym && nextProps.gym.id,
        wallId: nextProps.wall && nextProps.wall.id,
        gym: nextProps.gym,
        wall: nextProps.wall,
        walls: nextProps.gym && nextProps.gym.walls,
        problems: nextProps.problems || [],
        problemKey: nextProps.problemKey,
        activeProblem: nextProps.activeProblem,
      },
      () => {
        let promise = this.getWallAndHolds()
        if (this.state.activeProblem) {
          promise &&
            promise.then(() => {
              this.state.activeProblem &&
                this.setActiveProblem(this.state.activeProblem)
            })
        }
      },
    )
  }
  onResize() {
    let canvasWidth = window.innerWidth
    let canvasHeight = 0.8 * window.innerHeight
    let wScale = canvasWidth / this.state.imageWidth
    let hScale = canvasHeight / this.state.imageHeight
    let scale = wScale < hScale ? wScale : hScale
    let clientHeight = this.state.imageHeight * scale
    let clientWidth = this.state.imageWidth * scale
    this.setState({
      clientWidth: clientWidth,
      clientHeight: clientHeight,
      scale: scale,
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize)
  }

  handleHoldClick(hold, index) {
    let newHold = Object.assign({}, hold)
    newHold.selected = !newHold.selected
    let newHolds = Object.assign([], this.state.holds)
    newHolds[index] = newHold
    if (!newHold.selected) {
      newHold.startHold = false
      newHold.endHold = false
    }
    this.setState({
      holds: newHolds,
      activeHoldIndex: newHold.selected ? index : undefined,
    })
  }

  addHoldMetadata(holdIndex, metadata) {
    let newHold = Object.assign({}, this.state.holds[holdIndex], metadata)
    let newHolds = Object.assign([], this.state.holds)
    newHolds[holdIndex] = newHold
    this.setState({
      holds: newHolds,
      activeHoldIndex: undefined,
    })
  }

  handleListProblemsClick() {
    this.setState({
      isAddingProblem: false,
      activeProblem: undefined,
    })
  }
  handleAddProblemClick() {
    let isAddingProblem = true
    this.setState({
      isAddingProblem: isAddingProblem,
      activeProblem: undefined,
    })
  }

  handleAddProblem() {
    let isAddingProblem = false
    this.setState({
      isAddingProblem: isAddingProblem,
      activeProblem: undefined,
    })
  }

  afterAddProblem = e => {
    e && e.preventDefault()
    e && e.stopPropagation()
    let xmin, xmax, ymin, ymax
    let newHolds = this.state.holds.map(hold => {
      xmin = hold.xmin
      xmax = hold.xmax
      ymin = hold.ymin
      ymax = hold.ymax
      return {xmin, xmax, ymin, ymax}
    })
    if (this.state.problemKey) {
      this.props.history.push(
        UrlHelpers.wallPath(this.state.gymId, this.state.wallId),
      )
    }
    this.setState({
      holds: newHolds,
      isAddingProblem: false,
      isRecordingAscent: false,
      activeProblem: undefined,
      problemKey: undefined,
    })
  }

  handleEditProblemClick = e => {
    e.preventDefault()
    e.stopPropagation()
    this.setState({
      isAddingProblem: true,
    })
  }

  handleRecordAscentClick = e => {
    console.info('RECORDING ASCENT')
    e.preventDefault()
    e.stopPropagation()
    this.setState({
      isAddingProblem: false,
      isRecordingAscent: true,
    })
  }

  setActiveProblem(problem) {
    console.info('SETTING ACTIVE PROBLEM')
    let problemHolds = problem.holds
    let holds = this.state.holds
    let index
    _.each(problemHolds, hold => {
      if (hold.hasOwnProperty('index')) {
        holds[hold.index] = Object.assign({}, hold)
      } else {
        index = findHoldIndex(hold, holds)
        holds[index] = Object.assign({}, hold)
      }
    })
    this.setState({
      activeProblem: problem,
    })
  }

  setImageRef(imageRef) {
    let resize = this.resize
    this.imageRef = imageRef
    if (resize) {
      this.resize = false
      this.onResize()
    }
  }

  render() {
    // TODO: come up with better key for holds
    let wallUrl = (this.state.wall && this.state.wall.wallUrl) || undefined
    let scale = this.state.scale
    let scaledHeight =
      (this.state.imageHeight && this.state.imageHeight * scale) || '100%'
    // let scaledWidth  = (this.state.imageWidth && this.state.imageWidth*scale) || "100%"
    let isAddingProblem = this.state.isAddingProblem
    let isRecordingAscent = this.state.isRecordingAscent
    let holds = this.state.holds
    let gymId = this.state.gymId
    let gymName = (this.state.gym && this.state.gym.name) || gymId
    let wallName =
      (this.state.wall && this.state.wall.name) || this.state.wallId
    let wallId = this.state.wallId
    let walls = this.state.walls || []
    let loading = this.state.loading

    let clientWidth = this.state.clientWidth
    let clientHeight = this.state.clientHeight
    let imageWidth = this.state.imageWidth
    let imageHeight = this.state.imageHeight

    if (loading) {
      return (
        <div className="container">
          <Loading />
        </div>
      )
    }

    return (
      <div
        className="container"
        ref={ref => {
          this.containerRef = ref
        }}>
        <Header>
          <div className="breadcrumbs" style={{display: 'flex'}}>
            <Link to={UrlHelpers.gymPath(gymId)}>{gymName}</Link>
            <span className="pipe-span">|</span>
            <UncontrolledDropdown className="wall-dropdown">
              <DropdownToggle tag="div" className="wall-dropdown" caret>
                {wallName}
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem tag="div" key={wallId + 'edit'}>
                  <Link to={UrlHelpers.editWallPath(gymId, wallId)}>
                    Edit {wallName}
                  </Link>
                </DropdownItem>
                {_.map(walls, wall => {
                  return (
                    <DropdownItem tag="div" key={wall.id}>
                      <Link to={UrlHelpers.wallPath(gymId, wall.id)}>
                        {wall.name}
                      </Link>
                    </DropdownItem>
                  )
                })}
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
          <UserOrLogin />
        </Header>
        {wallUrl && (
          <DisplayWall
            wallUrl={wallUrl}
            holds={holds}
            setImageRef={this.setImageRef}
            scaledHeight={scaledHeight}
            scale={scale}
            handleHoldClick={(isAddingProblem && this.handleHoldClick) || false}
            unselectedStrokeOpacity={0.0}
            selectedFillOpacity={0.0}
            unselectedFillOpacity={0.0}
            clientWidth={clientWidth}
            clientHeight={clientHeight}
            imageWidth={imageWidth}
            imageHeight={imageHeight}
          />
        )}
        {!isAddingProblem && !this.state.activeProblem && (
          <h1 className="problem-header">Problems</h1>
        )}

        {isAddingProblem && (
          <EnsureUser>
            <AddProblem
              gymId={this.state.gymId}
              gymKey={this.state.gym.key}
              wallId={this.state.wallId}
              holds={this.state.holds}
              getProblems={this.getProblems}
              addProblemCallback={this.afterAddProblem}
              onCancel={this.afterAddProblem}
              addHoldMetadata={this.addHoldMetadata}
              activeHoldIndex={this.state.activeHoldIndex}
              activeProblem={this.state.activeProblem}
            />
          </EnsureUser>
        )}
        {isRecordingAscent && this.state.activeProblem && (
          <EnsureUser>
            <RecordAscent
              recordAscentCallback={this.afterAddProblem}
              onCancel={this.afterAddProblem}
              activeProblem={this.state.activeProblem}
            />
          </EnsureUser>
        )}
        {!isAddingProblem &&
          !this.state.activeProblem && [
            <ListProblems
              key="listproblems"
              problems={this.state.problems}
              activeProblem={this.state.activeProblem}
              setActiveProblem={this.setActiveProblem}
            />,
            <LaddaButton
              key="addproblem"
              onClick={this.handleAddProblemClick}
              data-color="mint"
              data-style={SLIDE_UP}
              data-spinner-color="#ddd"
              className={'floating-bottom-right-button'}>
              +
            </LaddaButton>,
          ]}
        {!isAddingProblem && !isRecordingAscent && this.state.activeProblem && (
          <Problem
            key="problem"
            problem={this.state.activeProblem}
            afterAddProblem={this.afterAddProblem}
            handleEditProblemClick={this.handleEditProblemClick}
            handleRecordAscentClick={this.handleRecordAscentClick}
          />
        )}
      </div>
    )
  }
}

export default Wall



// WEBPACK FOOTER //
// ./src/components/walls/Wall.jsx